import { HttpClient, type HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { REWARDS_CONTENT_CONFIG } from './config.token';
import { type RewardEntry } from './types';

const REWARDS_INDEX_KEY = '/csconfig/reward/index.json';

/** Raw rewards index may be a bare array or wrapped as `{ entries }`. */
type RewardsPayload = RewardEntry[] | { entries: RewardEntry[] };

@Injectable({
  providedIn: 'root',
})
export class RewardsContentService {
  http = inject(HttpClient);
  config = inject(REWARDS_CONTENT_CONFIG);

  getRewards(): Observable<RewardEntry[]> {
    return this.http.get<RewardsPayload>(`${this.config.baseUrl}${REWARDS_INDEX_KEY}`).pipe(
      catchError(this.handleError('rewards')),
      map((payload) => {
        if (Array.isArray(payload)) return payload;

        const entries = (payload as { entries?: unknown } | null)?.entries;

        return Array.isArray(entries) ? (entries as RewardEntry[]) : [];
      }),
    );
  }

  private handleError(resource: string) {
    return (error: HttpErrorResponse): Observable<never> =>
      throwError(() => new Error(`Failed to fetch ${resource}: ${error.status}`));
  }
}
